import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as functionalUsage from '../../../../records/plugins/functional-usage'
import type { Plugin } from '../plugin'

/**
 * Loads the Auto Lab Based functionalizations when the user selects the Auto
 * Lab Based methodology while editing a record's functional usage. Parameter
 * resolution lives in {@link loadForCurrentEntity}.
 */
export const loadOnMethodologySelected = store.effects.create(
  (feature: Plugin['feature'], _plugin: Plugin) =>
    ec.models.CollectionProducer.getEc$(ec.Name.Predefined.SpaceRecord, {
      waitUntilReady: true,
    }).pipe(
      rxjs.switchMap(recordsEc => {
        const functionalUsagePlugin = recordsEc.plugins
          .lookup(functionalUsage.Plugin)
          .get()

        return rxjs
          .combineLatest([
            functionalUsagePlugin.selectors.isUpdating.asObservable,
            functionalUsagePlugin.selectors.editingFunctionalUsage.asObservable,
          ])
          .pipe(
            rxjs.map(
              ([isUpdating, editing]) =>
                isUpdating &&
                editing?.functionalizationMethodology ===
                  ents.extra.space.Record.FunctionalUsage.Methodology
                    .AutoLabBased,
            ),
            rxjs.distinctUntilChanged(),
            rxjs.filter(Boolean),
            rxjs.map(() =>
              feature.actions.loadForCurrentEntity.request
                .from('(effect) load on Auto Lab Based methodology selected')
                .create(),
            ),
          )
      }),
    ),
)
